import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import riverDetail from './modules/riverDetail'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    riverDetail
  }
})
